export default defineNuxtRouteMiddleware(async (to) => {
  const { me, can, isAuthenticated } = useCurrentUser();
  const { $analytics } = useNuxtApp();

  const currentUser = useEnrichedCurrentUser();

  if (me.value) {
    await currentUser.ensureIsLoaded();

    if (import.meta.client && useState("identify_id").value !== me.value.id) {
      $analytics.identify(me.value.id, {
        email: me.value.email,
        signed_up: true,
        organization:
          currentUser.me.value?.organization_membership?.organization?.slug,
        /*
        Ensure no false contact form submission are sent here as this identify call is only
        used to attach email and org to the logged in user.
        As identify is also used to track form submissions, we need to ensure no false submissions are sent here.
        */
        website_contact_form: null,
      });
      useState("identify_id").value = me.value.id;
    }
  } else {
    currentUser.resetState();
  }

  if (isAuthenticated.value && to.name === "auth-login") {
    return await navigateTo((to.query.redirect as string) ?? "/");
  }

  if (to.meta.requiresAuthentication && !isAuthenticated.value) {
    return await navigateTo({
      name: "auth-login",
      hash: "#signin",
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (to.meta.requiresAdminAccess && !can("backoffice:access")) {
    throw createError({
      statusCode: 404,
      fatal: true,
    });
  }
});
